import { cn } from "@src/lib/utils";
import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  width?: "small" | "medium" | "large";
  styles?: string;
  disabled?: boolean;
  className?: string;
}

function Input(props: Props, ref: React.LegacyRef<HTMLInputElement>) {
  const { error, disabled, width = "medium", styles, className, ...rest } = props;

  const borderClass = cn(error ? "border-system-error-500" : "border-afya-lightgray-200");

  const disabledClass = cn(
    disabled &&
      "bg-body placeholder:text-gray-500 focus:outline-none bg-afya-lightgray-100 cursor-not-allowed",
    !disabled &&
      !error &&
      "bg-neutral-0 text-neutral-900 hover:border-neutral-500 focus:outline-none",
  );

  const sizeClass = cn(
    width === "small" && "py-2 px-3 text-[13px]",
    width === "medium" && "py-3 px-4 text-[15px]",
    width === "large" && "py-4 px-5 text-[16px]",
  );

  return (
    <input
      ref={ref}
      disabled={disabled}
      className={cn(
        "border border-solid appearance-none",
        "pr-10",
        "block w-full leading-tight text-neutral-900",
        "rounded focus:outline-none",
        borderClass,
        disabledClass,
        sizeClass,
        styles,
        className,
      )}
      {...rest}
    />
  );
}

export default React.forwardRef(Input);
